import React, { useState, useEffect } from "react";

import { styled } from "@mui/styles";
import {
  Grid,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  useMediaQuery,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import Body from "./body";
import DeleteModal from "../../../shared/deleteModal";

import dayjs from "dayjs";
require("dayjs/locale/th");
dayjs.locale("th");

const useStyles = makeStyles((theme) => ({
  DivCoverReturn: {
    width: "100%",
    height: "calc(100% - 30px)",
  },

  partOfAllCard: {
    width: "100%",
    height: "calc(100% - 100px)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: "15px",
    overflow: "hidden",
    overflowY: "auto",
    paddingTop: "20px",
    ["&::-webkit-scrollbar"]: {
      width: "10px",
      [theme.breakpoints.down("lg")]: {
        display: "none",
      },
    },
    ["&::-webkit-scrollbar-thumb"]: {
      backgroundColor: theme.palette.primary.main,
      borderRadius: "3px",
    },
  },
  TextNoBooking: {
    fontSize: "30px",
    textAlign: "center",
  },
  Grid: {
    width: "95%",
  },
  TableRow: {
    ["&:hover"]: {
      cursor: "pointer",
    },
  },
}));

const TextHeader = styled(Typography)(({ theme }) => ({
  fontSize: "14px",
  fontWeight: 600,
  color: theme.palette.text["secondary"],
}));

const CustomTableHead = ({ columns }) => (
  <TableHead
    sx={{
      "& .MuiTableCell-root:first-of-type": {
        borderTopLeftRadius: "8px",
        borderBottomLeftRadius: "8px",
      },
      "& .MuiTableCell-root:last-of-type": {
        borderTopRightRadius: "8px",
        borderBottomRightRadius: "8px",
      },
    }}
  >
    <TableRow
      sx={{
        "& .MuiTableCell-root": {
          borderBottom: "none",
          borderTop: "none",
        },
      }}
    >
      {columns.map((column) => (
        <TableCell
          key={column.id}
          style={{
            width: column.width,
            background: "#f4f6f8",
            position: "sticky",
            top: 0,
            zIndex: 1,
          }}
        >
          <TextHeader>{column.label}</TextHeader>
        </TableCell>
      ))}
    </TableRow>
  </TableHead>
);

const CustomTableFooter = ({
  count,
  rowsPerPage,
  page,
  onPageChange,
  onRowsPerPageChange,
}) => (
  <tfoot>
    <TableRow
      sx={{
        "& .MuiTableCell-root": {
          borderBottom: "none",
          borderTop: "none",
        },
      }}
    >
      <TablePagination
        rowsPerPageOptions={[5, 10, 25, 50, 100]}
        colSpan={9}
        count={count}
        rowsPerPage={rowsPerPage}
        page={page}
        slotProps={{
          select: {
            "aria-label": "rows per page",
          },
          actions: {
            showFirstButton: true,
            showLastButton: true,
          },
        }}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
        style={{
          position: "sticky",
          bottom: 0,
          background: "white",
          zIndex: 1,
        }}
      />
    </TableRow>
  </tfoot>
);

const HeaderFooter = ({
  columns,
  listAllBooking,
  typeOfBooking,
  onClickCardHandler,
  deliverySampleStatus,
  handleEditBooking,
  onClickDelete,
  setOpenDeleteModal,
  setDeletingBookingId,
  openDeleteModal,
  onClickCancel,
  setOpenCancelModal,
  setCancelBookingId,
  openCancelModal,
  listOfAction,
}) => {
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("md"));

  const onClickOpenDeleteModal = () => {
    setOpenDeleteModal(true);
  };
  const onCloseDeleteModalHandle = () => {
    setOpenDeleteModal(false);
  };

  const onClickOpenCancelModal = () => {
    setOpenCancelModal(true);
  };
  const onCloseCancelModalHandle = () => {
    setOpenCancelModal(false);
  };
  const emptyRows =
    page > 0
      ? Math.max(0, (1 + page) * rowsPerPage - listAllBooking.length)
      : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    setPage(0);
  }, [deliverySampleStatus]);

  return isMobile ? (
    <div className={`${classes.DivCoverReturn}`}>
      <Table>
        {listAllBooking && listAllBooking.length > 0 ? (
          <TableBody
            style={{
              height: "100%",
              overflow: "auto",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {(rowsPerPage > 0
              ? listAllBooking.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                )
              : listAllBooking
            ).map((booking, index) => (
              <Body
                key={index}
                bookingText={booking}
                typeOfBooking={typeOfBooking}
                onClickCardHandler={onClickCardHandler}
                handleEditBooking={handleEditBooking}
                onClickOpenDeleteModal={onClickOpenDeleteModal}
                onClickOpenCancelModal={onClickOpenCancelModal}
                setDeletingBookingId={setDeletingBookingId}
                setCancelBookingId={setCancelBookingId}
                listOfAction={listOfAction}
              />
            ))}
            {emptyRows > 0 && (
              <tr style={{ height: 41 * emptyRows }}>
                <td colSpan={3} aria-hidden />
              </tr>
            )}
          </TableBody>
        ) : (
          <Grid item xs={12} style={{ textAlign: "center" }}>
            <Typography style={{ fontSize: "24px" }}>ไม่มีรายการ</Typography>
          </Grid>
        )}
        <CustomTableFooter
          count={listAllBooking.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Table>
      <DeleteModal
        open={openDeleteModal}
        onCloseDeleteModalHandle={onCloseDeleteModalHandle}
        onClickDelete={onClickDelete}
        label={
          <>
            ลบรายการจอง
            <br />
            ข้อมูลการจองนี้จะหายไปและไม่สามารถกู้คืนได้
          </>
        }
      />
      <DeleteModal
        open={openCancelModal}
        onClickDelete={onClickCancel}
        onCloseDeleteModalHandle={onCloseCancelModalHandle}
        label={"ยกเลิกรายการจอง"}
      />
    </div>
  ) : (
    // !isMobile
    <div className={`${classes.DivCoverReturn}`}>
      {listAllBooking && listAllBooking.length > 0 ? (
        <TableContainer
          style={{
            height: "100%",
            overflow: "auto",
          }}
        >
          <Table stickyHeader>
            <CustomTableHead columns={columns} />
            <TableBody>
              {(rowsPerPage > 0
                ? listAllBooking.slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  )
                : listAllBooking
              ).map((booking, index) => (
                <Body
                  key={index}
                  bookingText={booking}
                  typeOfBooking={typeOfBooking}
                  onClickCardHandler={onClickCardHandler}
                  handleEditBooking={handleEditBooking}
                  onClickOpenDeleteModal={onClickOpenDeleteModal}
                  onClickOpenCancelModal={onClickOpenCancelModal}
                  setDeletingBookingId={setDeletingBookingId}
                  setCancelBookingId={setCancelBookingId}
                  listOfAction={listOfAction}
                />
              ))}
              {emptyRows > 0 && (
                <tr style={{ height: 41 * emptyRows }}>
                  <td colSpan={3} aria-hidden />
                </tr>
              )}
            </TableBody>
            <CustomTableFooter
              count={listAllBooking.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Table>
        </TableContainer>
      ) : (
        <Grid item xs={12} style={{ textAlign: "center" }}>
          <Typography style={{ textAlign: "center", fontSize: "24px" }}>
            ไม่มีรายการ
          </Typography>
        </Grid>
      )}
      <DeleteModal
        open={openDeleteModal}
        onCloseDeleteModalHandle={onCloseDeleteModalHandle}
        onClickDelete={onClickDelete}
        label={
          <>
            ลบรายการจอง
            <br />
            ข้อมูลการจองนี้จะหายไปและไม่สามารถกู้คืนได้
          </>
        }
      />
      <DeleteModal
        open={openCancelModal}
        onClickDelete={onClickCancel}
        onCloseDeleteModalHandle={onCloseCancelModalHandle}
        label={"ยกเลิกรายการจอง"}
      />
    </div>
  );
};

export default HeaderFooter;
